import { Component, computed, input } from '@angular/core';

// Avviso del flusso nuovo cliente: informativo o di attenzione
@Component({
  selector: 'ord-new-customer-banner',
  template: `
    <div class="banner" [class.banner--warning]="type() === 'warning'">
      <i [class]="iconClass()" aria-hidden="true"></i>
      <div class="banner-text">
        @if (title()) {
          <span class="body-medium-emphasized banner-title">{{ title() }}</span>
        }
        @if (message()) {
          <span class="body-medium">{{ message() }}</span>
        }
        <ng-content />
      </div>
    </div>
  `,
  styles: `
    :host {
      display: block;
    }

    .banner {
      display: flex;
      align-items: center;
      gap: var(--mat-sys-spacing-16);
      padding: var(--mat-sys-spacing-16);
      border-radius: var(--mat-sys-corner-medium);
      color: var(--mat-sys-on-info-container);
      background-color: var(--mat-sys-info-container);
    }

    .banner > i {
      flex: 0 0 auto;
      font-size: 24px;
      color: var(--mat-sys-info);
    }

    .banner--warning {
      color: var(--mat-sys-on-warning-container);
      background-color: var(--mat-sys-warning-container);
    }

    .banner--warning > i {
      color: var(--mat-sys-warning);
    }

    .banner-text {
      display: grid;
      gap: var(--mat-sys-spacing-8);
      min-width: 0;
    }
  `,
})
export class NewCustomerBanner {
  readonly type = input<'info' | 'warning'>('info');
  readonly title = input<string>();
  readonly message = input<string>();
  readonly icon = input<string>();

  readonly iconClass = computed(
    () => this.icon() ?? (this.type() === 'warning' ? 'fa-solid fa-triangle-exclamation' : 'fa-solid fa-circle-info'),
  );
}
